import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { logger } from "@/lib/logger";
import { History } from "lucide-react";

const META = {
  seed: { label: "Demo Load", cls: "bg-blue-50 text-blue-600" },
  clear: { label: "Clear", cls: "bg-red-50 text-red-600" },
  import: { label: "Import", cls: "bg-indigo-50 text-indigo-600" },
  restore: { label: "Restore", cls: "bg-emerald-50 text-emerald-700" },
};

function detail(a) {
  if (a.action === "clear") return ` · ${(a.sections || []).includes("all") ? "everything" : (a.sections || []).join(", ")} · ${a.total} records`;
  if (a.action === "import") return ` · ${a.entity} · ${a.created} created${a.updated ? `, ${a.updated} updated` : ""}${a.skipped ? `, ${a.skipped} skipped` : ""}`;
  if (a.action === "restore") return ` · ${a.total} records restored`;
  return "";
}

// Audit trail of destructive/data-tool actions; `refreshKey` re-fetches after each action.
export default function ResetAudit({ refreshKey }) {
  const [audit, setAudit] = useState([]);
  const load = useCallback(async () => {
    try { const res = await api.get(`/admin/reset-audit`); setAudit(res?.entries || []); }
    catch (e) { logger.error("Failed to load reset audit:", e); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-3">
        <History className="h-4 w-4 text-slate-500" />
        <h3 className="font-display text-sm font-semibold text-slate-900">Reset Activity</h3>
      </div>
      {audit.length === 0 ? (
        <p className="text-xs text-slate-400" data-testid="audit-empty">No resets recorded yet.</p>
      ) : (
        <ul className="space-y-2 max-h-56 overflow-y-auto pr-1" data-testid="audit-list">
          {audit.map((a, i) => {
            const meta = META[a.action] || { label: a.action, cls: "bg-slate-100 text-slate-600" };
            return (
              <li key={a.id || i} className="text-xs border-b border-slate-50 pb-2 last:border-0" data-testid="audit-row">
                <div className="flex items-center justify-between">
                  <span className={`font-semibold uppercase text-[10px] px-1.5 py-0.5 rounded ${meta.cls}`}>{meta.label}</span>
                  <span className="text-slate-400">{a.at ? new Date(a.at).toLocaleString("en-IN") : ""}</span>
                </div>
                <div className="text-slate-500 mt-1">by <span className="font-medium text-slate-700">{a.by_name || a.by}</span>{detail(a)}</div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
